var ScoutingFiltersController = (function () {
    function ScoutingFiltersController($state, ScoutingReportResource, ScoutingFilterService) {
        this.$state = $state;
        this.$reportResource = ScoutingReportResource;
        this.$filterService = ScoutingFilterService;
    }
    ScoutingFiltersController.prototype.$onChanges = function (changes) {
        if (changes.viewType || changes.showPublic) {
            this.updateFiltersStatistics();
        }
    };
    ScoutingFiltersController.prototype.update = function () {
        this.updateFiltersStatistics();
        this.onFiltersChanged();
        this.$state.transitionTo(this.$state.$current.name, this.$filterService.serialize(this.filters), {
            location: 'replace',
            inherit: false,
            notify: false,
        });
    };
    ScoutingFiltersController.prototype.updateFiltersStatistics = function () {
        var _this = this;
        this.filterStatisticsPromise = this.$reportResource.getFiltersStatistics({ type: this.viewType, showPublic: this.showPublic ? 1 : -1 }, { filters: this.filters }).$promise;
        this.filterStatisticsPromise.then(function (result) { return (_this.filterStatisticsData = result); });
    };
    return ScoutingFiltersController;
}());
angular.module('app.scouting').component('scoutingFilters', {
    templateUrl: 'scouting/components/filters/filters.html',
    controller: ScoutingFiltersController,
    bindings: {
        viewType: '<',
        filters: '<',
        onFiltersChanged: '&',
        showPublic: '<',
    },
});
;